import { useCallback, useEffect, useRef } from "react";
import GSChatService from "services/GSChatService";
import { useTranslate } from "hooks/translation";
import audioUrl from "assets/audios/messageNotification.wav";

function changeFavicon(url: string) {
  const head = document.head;

  document.querySelectorAll("link[rel~='icon']").forEach(el => el.remove());

  const favicon = document.createElement('link');
  favicon.rel = 'icon';
  favicon.type = 'image/png';
  favicon.href = `${url}?v=${Date.now()}`;

  head.appendChild(favicon);
}

export const useSoundMessageNotifications = () => {
  const { translate } = useTranslate();
  const state = useRef({
    isTabActive: true,
    audio: new Audio(audioUrl),
    initialTitle: document.title,
    titleIntervalId: null
  });

  const notify = useCallback(async () => {
    clearInterval(state.current.titleIntervalId);
    state.current.titleIntervalId = null;

    if (!state.current.isTabActive) {
      changeFavicon('/notifyFavicon.ico');
      document.title = translate("notifications.unreads.title", { count: GSChatService.unreadCount.toString() });

      try {
        await state.current.audio.play();
      } catch (err) {
        console.warn("Error due sound effect", err);
      }

      state.current.titleIntervalId = setInterval(() => {
        if (document.title === state.current.initialTitle) {
          changeFavicon('/notifyFavicon.ico');
          document.title = translate("notifications.unreads.title", { count: GSChatService.unreadCount.toString() });
        } else {
          changeFavicon('/favicon.ico');
          document.title = state.current.initialTitle;
        }
      }, 2000);
    }
  }, [GSChatService.unreadCount])

  useEffect(() => {
    setTimeout(() => {
      state.current.initialTitle = document.title;
    }, 1000);

    const handleVisibilityChange = () => {
      state.current.isTabActive = !document.hidden;

      if (state.current.isTabActive) {
        clearInterval(state.current.titleIntervalId);
        state.current.titleIntervalId = null;

        document.title = state.current.initialTitle;

        changeFavicon('/favicon.ico');
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    };
  }, []);

  return { notify };
};
